import { render, staticRenderFns } from "./NewsArticleStyleOne.vue?vue&type=template&id=0c7b2855&scoped=true&"
import script from "./NewsArticleStyleOne.vue?vue&type=script&lang=ts&"
export * from "./NewsArticleStyleOne.vue?vue&type=script&lang=ts&"
import style0 from "./NewsArticleStyleOne.vue?vue&type=style&index=0&id=0c7b2855&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7b2855",
  null
  
)

export default component.exports